import "../css/modalfixed.css";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

function ModalFixed(props) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(true);

  const mystyle = {
    backgroundColor: props.color,
  };

  return (
    <div className="mf-wrapper">
      {/* Trigger */}
      <motion.div
        initial={{ x: 40, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
      >
        <div
          className="mf-trigger"
          style={mystyle}
          onClick={() => setOpen(true)}
        >
          <p>{props.title}</p>
          <ChevronRight color="white" size={40} />
        </div>
      </motion.div>

      {/* Content */}
      {open && (
        <motion.div
          className="mf-panel"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={() => setOpen(false)}
        >
          <div
            className="mf-box"
            onClick={(e) => e.stopPropagation()} // evita cerrar al hacer click dentro
          >
            <span
              className="material-icons mf-close"
              onClick={() => setOpen(false)}
            >
              close
            </span>
            {props.content}
          </div>
        </motion.div>
      )}
    </div>
  );
}

export default ModalFixed;
